// extracted by mini-css-extract-plugin
export default {"section":"PortfolioSection_section__cnyM2","grid":"PortfolioSection_grid__9WV1G","more":"PortfolioSection_more__gjdI8"};